import React from "react";
import ProjectsListing from "../ProjectListing/ProjectListing";

const Commercial = () => {
  return (
    <ProjectsListing categoryKey="commercialProjects" baseUrl="commercial" />
  );
};

export default Commercial;
